import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  Tooltip,
  IconButton,
  TextField,
  CircularProgress,
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  useMediaQuery,
  Grid,
  Container,
  Fade,
  Card,
  CardContent,
  Divider,
  Stack
} from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { useAppContext } from './AppProvider';
import { useAuth0 } from '@auth0/auth0-react';
import ThirdColumn from './components/ThirdColumn';
import { useNavigate } from 'react-router-dom';
import {useEffect} from 'react'
import CreditBreakdown from './components/CreditBreakdown';
import AuthDialog from './AuthDialog';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ShareIcon from '@mui/icons-material/Share';
import TelegramIcon from '@mui/icons-material/Telegram';

// Custom styles
const styles = {
  pageContainer: {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    paddingBottom: 4
  },
  header: {
    backdropFilter: 'blur(10px)',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderBottom: '1px solid rgba(0, 102, 255, 0.2)',
    position: 'sticky',
    top: 0,
    zIndex: 1000
  },
  mainCard: {
    borderRadius: 2,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
    }
  },
  button: {
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    }
  },
  tableContainer: {
    borderRadius: 2,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    '& .MuiTableCell-head': {
      fontWeight: 600,
      backgroundColor: '#f5f5f5'
    }
  },
  shareButton: {
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    transition: 'all 0.2s ease',
    padding: '8px 16px',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    }
  },
  whatsappButton: {
    backgroundColor: '#25D366',
    color: 'white',
    '&:hover': {
      backgroundColor: '#128C7E',
    }
  },
  telegramButton: {
    backgroundColor: '#0088cc',
    color: 'white',
    '&:hover': {
      backgroundColor: '#006699',
    }
  },
  shareGenericButton: {
    backgroundColor: '#1a73e8',
    color: 'white',
    '&:hover': {
      backgroundColor: '#1557b0',
    }
  }
};

const Referral = () => {
  
  const [referralCode, setReferralCode] = useState('');
  const [copied, setCopied] = useState(false);
  const [redeemCode, setRedeemCode] = useState('');
  const [redeemMessage, setRedeemMessage] = useState('');
  const [loadingReferral, setLoadingReferral] = useState(false);
  const [loadingRedeem, setLoadingRedeem] = useState(false);
  const [rewardHistory, setRewardHistory] = useState([]);
  const [loadingRewards, setLoadingRewards] = useState(false);
  const {fetchSubscriptionStatus, backendUrl, accessToken} = useAppContext()

  // New state for config values
  const [creditConfig, setCreditConfig] = useState({ credit_amount: 150, max_redemptions: 10 });

  // Fetch config on mount
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch(`${backendUrl}/get-credit-amount-config`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });
        if (response.ok) {
          const data = await response.json();
          setCreditConfig({
            credit_amount: data.credit_amount ?? 150,
            max_redemptions: data.max_redemptions ?? 10,
          });
        }
      } catch (err) {
        // fallback to defaults
      }
    };
    fetchConfig();
  }, [backendUrl]);

  //const { backendUrl } = useAppContext();
  const { user, isAuthenticated, getAccessTokenSilently, loginWithPopup } = useAuth0();
  const navigate = useNavigate()
   // Responsive Design
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    const [isAuthDialogOpen, setAuthDialogOpen] = useState(false);

  const handleLogin = async () => {
    try {
      await loginWithPopup();
      setAuthDialogOpen(false);     // Close dialog on success
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const getUserDetails = async () => {
    try {
      const response = await fetch(`${backendUrl}/get-user-signup-date?user_id=${encodeURIComponent(user.sub)}`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });
      const data = await response.json();
      console.log("User signed up at:", data.created_at);
    } catch (err) {
      console.error("Failed to fetch user signup time", err);
    }
  };

  useEffect(() => {
    //getUserDetails()
  }, [])

  
  

  const handleGenerateReferral = async () => {
    if(!isAuthenticated) {
      setAuthDialogOpen(true);
    }
    else {
    setLoadingReferral(true);
    setReferralCode('');
    setCopied(false);
    try {
      const response = await fetch(`${backendUrl}/generate-referral-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' , 'Authorization': `Bearer ${accessToken}`},
        body: JSON.stringify({
          user_email: user?.email,
          purpose_type: 'joining',
          expiry_type: 'lifetime',
          credit_amount: 150,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to generate referral code');
      }

      const data = await response.json();
      setReferralCode(data.referral_code);
    } catch (error) {
      console.error('Error generating referral code:', error);
    } finally {
      setLoadingReferral(false);
    }
  }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(referralCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleRedeemReferral = async () => {
    if(!isAuthenticated) {
      setAuthDialogOpen(true);
    }
    else{
    setLoadingRedeem(true);
    setRedeemMessage('');
    try {
      const response = await fetch(`${backendUrl}/redeem-referral`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify({
          referral_code: redeemCode,
          redeemer_email: user?.email,
          user_id : user?.sub
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to redeem referral code');
      }

      setRedeemMessage(data.message);
      fetchSubscriptionStatus()
    } catch (error) {
      console.error('Error redeeming referral code:', error);
      setRedeemMessage(error.message);
    } finally {
      setLoadingRedeem(false);
    }
  }
  };

  const fetchRewardHistory = async () => {
    setLoadingRewards(true);
    try {
      const response = await fetch(`${backendUrl}/get-user-reward-history?user_email=${encodeURIComponent(user?.email)}`, {
        headers: { 'Content-Type': 'application/json' , 'Authorization': `Bearer ${accessToken}`}
      });

      const data = await response.json();
      setRewardHistory(data.reward_logs || []);
    } catch (err) {
      console.error('Error fetching reward history:', err);
    } finally {
      setLoadingRewards(false);
    }
  };

  useEffect(() => {
    if (user?.email) {
      fetchRewardHistory();
    }
  }, [user?.email, loadingRedeem, accessToken]);

  const getShareMessage = () => {
    return `Join me on https://app.facticity.ai! Use my referral code ${referralCode} to get 150 bonus credits when you sign up.
  
  Facticity AI lets you fact-check news, claims, text, and video content in real time. Just enter a claim, paragraph, or audio/video link—Facticity will analyze sources, detect false or misleading claims, and provide real-time insights.
  
  Let's get fact-checking!`;
  };
  

  const handleShare = async () => {
    const shareData = {
      title: 'Join Facticity.AI',
      text: getShareMessage(),
      url: 'https://app.facticity.ai'
    };

    try {
      if (navigator.share) {
        await navigator.share({
          title: shareData.title,
          text: shareData.text,
          url: shareData.url
        });
      } else {
        // Fallback for browsers that don't support navigator.share
        await navigator.clipboard.writeText(`${shareData.text}\n\n${shareData.url}`);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    } catch (error) {
      console.error('Error sharing:', error);
      // Fallback to copying to clipboard
      await navigator.clipboard.writeText(`${shareData.text}\n\n${shareData.url}`);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleWhatsAppShare = () => {
    const message = encodeURIComponent(getShareMessage());
    window.open(`https://wa.me/?text=${message}`, '_blank');
  };

  const handleTelegramShare = () => {
    const message = encodeURIComponent(getShareMessage());
    window.open(`https://t.me/share/url?url=https://facticity.ai&text=${message}`, '_blank');
  };

  const handleCopyMessage = () => {
    navigator.clipboard.writeText(getShareMessage());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box sx={styles.pageContainer}>
      {/* Header Section */}
      <Grid
        container
        item
        xs={12}
        sx={{
          ...styles.header,
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingY: { xs: 1, sm: 2 },
          paddingX: { xs: 1, sm: 2 },
        }}
      >
        <a href="https://facticity.ai" style={{ textDecoration: 'none' }}>
          <img
            src="/facticityailogo-02.png"
            alt="Facticity.AI"
            style={{
              paddingTop: isMdUp ? '2px' : '3px',
              width: 'auto',
              height: isMdUp ? '32px' : '26px',
            }}
          />
        </a>
        
        {(!isAuthenticated || isMdUp) && (
          <Box sx={{ position: 'absolute', right: 15 }}>
            <ThirdColumn />
          </Box>
        )}
      </Grid>

      <Container maxWidth="md" sx={{ mt: 4 }}>
        <AuthDialog
          open={isAuthDialogOpen}
          onClose={() => setAuthDialogOpen(false)}
          onLogin={handleLogin}
        />

        <Fade in timeout={800}>
          <Box sx={{ mb: 4 }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={() => navigate('/')}
              sx={styles.button}
            >
              Back to Dashboard
            </Button>
          </Box>
        </Fade>

        {/* Credits Section */}
        <Fade in timeout={1000}>
          <Card sx={{ ...styles.mainCard, mb: 3 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#1a73e8' }}>
                Credits Breakdown
              </Typography>
              <Divider sx={{ my: 2 }} />
              {loadingRedeem ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                  <CircularProgress />
                </Box>
              ) : (
                <CreditBreakdown loadingReferral={loadingReferral} />
              )}
            </CardContent>
          </Card>
        </Fade>

        {/* Referral & Rewards Section */}
        <Fade in timeout={1200}>
          <Card sx={styles.mainCard}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <CardGiftcardIcon sx={{ mr: 1, color: '#1a73e8' }} />
                <Typography variant="h5" sx={{ fontWeight: 600, color: '#1a73e8' }}>
                  Referral & Rewards
                </Typography>
              </Box>
              
              <Typography variant="body1" sx={{ mb: 3, color: '#666' }}>
                Share Facticity.AI with your friends and both get {creditConfig.credit_amount} lifetime credits! You can refer up to {creditConfig.max_redemptions} people.
                Note: Generate and share your referral code before your friend creates their account.
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {/* Generate Code Section */}
                <Box>
                  <Button
                    variant="contained"
                    onClick={handleGenerateReferral}
                    disabled={loadingReferral}
                    sx={{
                      ...styles.button,
                      backgroundColor: '#1a73e8',
                      '&:hover': {
                        backgroundColor: '#1557b0',
                      }
                    }}
                    fullWidth
                  >
                    {loadingReferral ? <CircularProgress size={24} color="inherit" /> : 'Generate Referral Code'}
                  </Button>

                  {referralCode && (
                    <Fade in timeout={500}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                          <TextField
                            label="Your Referral Code"
                            value={referralCode}
                            InputProps={{
                              readOnly: true,
                              sx: { borderRadius: '8px' }
                            }}
                            fullWidth
                            variant="outlined"
                          />
                          <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'}>
                            <IconButton
                              onClick={handleCopy}
                              color="primary"
                              sx={{
                                ...styles.button,
                                backgroundColor: copied ? '#e8f5e9' : 'transparent'
                              }}
                            >
                              {copied ? <CheckCircleIcon color="success" /> : <ContentCopyIcon />}
                            </IconButton>
                          </Tooltip>
                        </Box>
                        
                        <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                          Share your referral code:
                        </Typography>
                        
                        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                          <Tooltip title="Share via WhatsApp">
                            <IconButton
                              onClick={handleWhatsAppShare}
                              sx={{ 
                                ...styles.shareButton, 
                                backgroundColor: '#25D366',
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: '#128C7E',
                                }
                              }}
                            >
                              <WhatsAppIcon />
                            </IconButton>
                          </Tooltip>
                          
                          <Tooltip title="Share via Telegram">
                            <IconButton
                              onClick={handleTelegramShare}
                              sx={{ 
                                ...styles.shareButton, 
                                backgroundColor: '#0088cc',
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: '#006699',
                                }
                              }}
                            >
                              <TelegramIcon />
                            </IconButton>
                          </Tooltip>
                          
                          <Tooltip title="Share">
                            <IconButton
                              onClick={handleShare}
                              sx={{ 
                                ...styles.shareButton, 
                                backgroundColor: '#1a73e8',
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: '#1557b0',
                                }
                              }}
                            >
                              <ShareIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title={copied ? 'Message copied!' : 'Copy message'}>
                            <IconButton
                              onClick={handleCopyMessage}
                              sx={{ 
                                ...styles.shareButton, 
                                backgroundColor: copied ? '#e8f5e9' : '#f5f5f5',
                                color: copied ? '#2e7d32' : '#666',
                                '&:hover': {
                                  backgroundColor: copied ? '#e8f5e9' : '#eeeeee',
                                }
                              }}
                            >
                              {copied ? <CheckCircleIcon /> : <ContentCopyIcon />}
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </Box>
                    </Fade>
                  )}
                </Box>

                <Divider />

                {/* Redeem Code Section */}
                <Box>
                  <Typography variant="h6" gutterBottom sx={{ color: '#1a73e8' }}>
                    Redeem a Code
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <TextField
                      label="Enter Referral Code"
                      value={redeemCode}
                      onChange={(e) => setRedeemCode(e.target.value)}
                      fullWidth
                      variant="outlined"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                    />
                    <Button
                      variant="outlined"
                      onClick={handleRedeemReferral}
                      disabled={loadingRedeem}
                      sx={styles.button}
                    >
                      {loadingRedeem ? <CircularProgress size={24} /> : 'Redeem'}
                    </Button>
                  </Box>

                  {redeemMessage && (
                    <Fade in timeout={500}>
                      <Alert 
                        severity="info" 
                        sx={{ 
                          mt: 2,
                          borderRadius: '8px',
                          '& .MuiAlert-message': { color: '#1a73e8' }
                        }}
                      >
                        {redeemMessage}
                      </Alert>
                    </Fade>
                  )}
                </Box>

                <Divider />

                {/* Reward History Section */}
                <Box>
                  <Typography variant="h6" gutterBottom sx={{ color: '#1a73e8' }}>
                    Reward History
                  </Typography>
                  
                  {loadingRewards ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                      <CircularProgress />
                    </Box>
                  ) : rewardHistory.length === 0 ? (
                    <Typography variant="body1" sx={{ color: '#666', textAlign: 'center', py: 3 }}>
                      No rewards yet. Start referring friends to earn credits!
                    </Typography>
                  ) : (
                    <TableContainer component={Paper} sx={styles.tableContainer}>
                      <Table size="medium">
                        <TableHead>
                          <TableRow>
                            <TableCell>Credits</TableCell>
                            <TableCell>Source</TableCell>
                            <TableCell>Referral/Promo</TableCell>
                            <TableCell>Earned</TableCell>
                            <TableCell>Expires</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rewardHistory.map((log) => (
                            <TableRow 
                              key={log._id}
                              sx={{
                                '&:hover': {
                                  backgroundColor: '#f5f5f5',
                                  transition: 'background-color 0.2s ease'
                                }
                              }}
                            >
                              <TableCell>{log.amount}</TableCell>
                              <TableCell>{log.source}</TableCell>
                              <TableCell>{log.referral_code}</TableCell>
                              <TableCell>{new Date(log.timestamp).toLocaleDateString()}</TableCell>
                              <TableCell>
                                {log.expiry === 'lifetime' ? 'No Expiry' : new Date(log.expiry).toLocaleDateString()}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Fade>
      </Container>
    </Box>
  );
};

export default Referral;
